import Regex from './Regex'

export default class PhoneNumberInternational extends Regex {
  get ruleName () {
    return 'phoneNumberInternational'
  }

  passes () {
    /*
    * Pourquoi cette version fonctionne ?
     Elle est divisée en deux grandes parties grâce au symbole "OU" (|) :
     Le bloc International ((?:\+|00)\d{1,3} ...) :
     Accepte + ou 00.
     Suit avec un indicatif pays de 1 à 3 chiffres (ex: 1 pour USA, 33 pour France, 212 pour Maroc).
     Autorise un séparateur optionnel (espace, point, tiret).
     Gère les parenthèses autour de l'indicatif régional (très commun aux USA : +1 (555)).
     Le bloc Local Français (|0) :
     Si le numéro ne commence pas par un format international, il doit obligatoirement commencer par 0.
     Le corps du numéro ([0-9\s.\-]{6,14}) :
     Accepte entre 6 et 14 caractères composés de chiffres, d'espaces, de points ou de tirets. Cela couvre la majorité des longueurs mondiales tout en restant flexible sur le style de saisie.


     Format,Exemple,Statut
     Local FR,06 50 50 50 50,✅ Valide
     International (USA),+1 555-555-5555,✅ Valide
     International (UK),+44 20 7123 4567,✅ Valide
     Format 00,0033 6 50 50 50 50,✅ Valide
     International (Parenthèses),+1 (555) 555-5555,✅ Valide
     * */
    return super.passes(/^(?:(?:\+|00)\d{1,3}[\s.\-]?\(?\d{1,4}?\)?|0)[0-9\s.\-]{6,14}$/)
  }
}
